function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.122317 11.819C1.47064 8.34235 2.39471 4.86324 3.64359 1.38624C3.72513 1.16082 3.12655 0.681005 5.61571 0.596386C8.20364 0.508306 10.8002 0.874915 11.471 1.11749C12.3427 1.4325 11.8542 1.83356 11.9377 2.16234C12.0504 2.60476 12.0153 3.02515 11.7468 3.46608C10.7226 5.14621 9.39353 6.82348 8.36737 8.50399C7.78668 9.45534 7.09861 10.406 6.36081 11.3559C6.16393 11.6093 6.77511 12.3616 4.91702 12.539C3.77221 12.6483 2.0036 12.5325 1.12063 12.4245C-0.332429 12.2466 -0.0029694 12.0421 0.122317 11.819Z",
  fill: "#297DDC"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.1223 11.819C29.4706 8.34235 30.3947 4.86324 31.6436 1.38624C31.7251 1.16082 31.1265 0.681005 33.6157 0.596386C36.2036 0.508306 38.8002 0.874915 39.471 1.11749C40.3427 1.4325 39.8542 1.83356 39.9377 2.16234C40.0504 2.60476 40.0153 3.02515 39.7468 3.46608C38.7226 5.14621 37.3935 6.82348 36.3674 8.50399C35.7867 9.45534 35.0986 10.406 34.3608 11.3559C34.1639 11.6093 34.7751 12.3616 32.917 12.539C31.7722 12.6483 30.0036 12.5325 29.1206 12.4245C27.6676 12.2466 27.997 12.0421 28.1223 11.819Z",
  fill: "#A9DBFB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.1223 11.819C57.4706 8.34235 58.3947 4.86324 59.6436 1.38624C59.7251 1.16082 59.1265 0.681005 61.6157 0.596386C64.2036 0.508306 66.8002 0.874915 67.471 1.11749C68.3427 1.4325 67.8542 1.83356 67.9377 2.16234C68.0504 2.60476 68.0153 3.02515 67.7468 3.46608C66.7226 5.14621 65.3935 6.82348 64.3674 8.50399C63.7867 9.45534 63.0986 10.406 62.3608 11.3559C62.1639 11.6093 62.7751 12.3616 60.917 12.539C59.7722 12.6483 58.0036 12.5325 57.1206 12.4245C55.6676 12.2466 55.997 12.0421 56.1223 11.819Z",
  fill: "#A9DBFB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M84.1223 11.819C85.4706 8.34235 86.3947 4.86324 87.6436 1.38624C87.7251 1.16082 87.1265 0.681005 89.6157 0.596386C92.2036 0.508306 94.8002 0.874915 95.471 1.11749C96.3427 1.4325 95.8542 1.83356 95.9377 2.16234C96.0504 2.60476 96.0153 3.02515 95.7468 3.46608C94.7226 5.14621 93.3935 6.82348 92.3674 8.50399C91.7867 9.45534 91.0986 10.406 90.3608 11.3559C90.1639 11.6093 90.7751 12.3616 88.917 12.539C87.7722 12.6483 86.0036 12.5325 85.1206 12.4245C83.6676 12.2466 83.997 12.0421 84.1223 11.819Z",
  fill: "#A9DBFB"
});

function SvgPattern({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 13,
    viewBox: "0 0 96 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.ec5dfa06e48b01e8cb6603e7201fcb16.svg";
export { ForwardRef as ReactComponent };